import { CMMBranch } from '@fruitful/types';
import { useFeatureGate } from '@statsig/expo-bindings';

import { FeatureFlags } from '../../feature-flags/FeatureFlags';

const useNewArtifact = (branch?: CMMBranch | null) => {
    const { value: newArtifactEnabled } = useFeatureGate(
        FeatureFlags.ENABLE_ARTIE_THE_ARTIFACT,
    );

    return (
        newArtifactEnabled &&
        branch != null &&
        [CMMBranch.GoalsDebt, CMMBranch.GoalsSystem].includes(branch)
    );
};

export default useNewArtifact;
